import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=14d1d8e5&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=14d1d8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d1d8e5",
  null
  
)

export default component.exports